import React, { useState, useEffect, useRef } from 'react';
import styled from 'styled-components';

const ChoiceSwitch = ({ options = ['Message', 'Speak'], active = 'Message', onChange, videoMode }) => {
  const [selected, setSelected] = useState(active);
  const containerRef = useRef();
  const optionRefs = useRef([]);

  useEffect(() => {
    setSelected(active);
  }, [active]);

  const handleOptionClick = (option) => {
    if (option !== selected) {
      setSelected(option);
      onChange(option);
    }
  };

  const selectedIndex = options.indexOf(selected);

  return (
    <Container ref={containerRef} videoMode={videoMode}>
      <Slider
        videoMode={videoMode}
        style={{
          width: optionRefs.current[selectedIndex]?.offsetWidth + 5 || 0,
          left:
            optionRefs.current
              .slice(0, selectedIndex)
              .reduce((sum, ref) => sum + (ref?.offsetWidth || 0), 0) || 0,
        }}
      />
      {options.map((option, i) => (
        <Option
          videoMode={videoMode}
          key={option}
          ref={el => (optionRefs.current[i] = el)}
          active={selected === option}
          onClick={() => handleOptionClick(option)}
        >
          {option}
        </Option>
      ))}
    </Container>
  );
};

export default ChoiceSwitch;

const Slider = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  background-color: ${props => props.videoMode ? 'rgba(255,255,255,0.9)' : 'rgba(0,0,0,0.7)'};
  border-radius: 100px;
  transition: all 0.3s ease;
  z-index: 1;
`;


const Container = styled.div`
  display: flex;
  background: ${props => props.videoMode ? 'rgba(255, 255, 255, 0.3)' : '#ffffff' };
  border-radius: 100px;
  position: relative;
  overflow: hidden;
  cursor: pointer;
  padding: 2px;
  transform: scale(1.00);
  transition: all 0.5s;
  z-index:1000;

  &:hover {
        transform: scale(1.02);
    }
`;

// rgba(211, 227, 248, 1)

const Option = styled.div`
  font-family: newFontFace;
  font-size: 14px;
  font-weight: 500;
  padding: 8px 16px;
  text-align: center;
  z-index: 2;
  color: ${props => ((props.active && props.videoMode) || (!props.active && !props.videoMode)  ? '#000000' : '#ffffff')};
  transition: color 0.3s;
`;
